// 45be085d06f2b331b038fb65c016444f3a7ecebd|kind=api-js|className=IndustryApi|type=angular|apiName=am|apiEnumKey=AM|operationHash=b7bd11fd65c4400e5bc1a6c0597a526b1f683eb7

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';

import { parseOkResponseWrappingIndustryListFromJSON } from '../../../parsers/OkResponseWrappingIndustryList';

export class IndustryApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @tags IndustryApi
   * @name IndustryApiGetIndustryList
   * @summary Get all industries
   * @request GET:/industries
   */
  getIndustryList(
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/industries`,
        method: 'GET',
        api: Api.AM,
      },
      {
        ...requestOptions,
        parser: parseOkResponseWrappingIndustryListFromJSON,
      },
    );
  }

  static ɵfac = function IndustryApi_Factory(t) { return new (t || IndustryApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: IndustryApi, factory: IndustryApi.ɵfac, providedIn: 'root' });
}
